import type { AgentPageSeo, FAQItem } from "../agent-seo";

export const faqs: FAQItem[] = [
  {
    question: "What does the Tailored Apply Agent do?",
    answer:
      "Open a job in Chrome and click Tailored Apply. The agent reads the job description, tailors your resume to it, fills in the application from your profile and submits it with the tailored PDF attached.",
  },
  {
    question: "How is it different from Auto Apply?",
    answer:
      "Auto Apply runs in the background and applies to many matching jobs on a schedule. Tailored Apply works on one job at a time that you choose yourself, so it suits the roles you want most.",
  },
  {
    question: "What does it change on my resume?",
    answer:
      "It adjusts your headline, summary, the order of your bullets and your skills list so the experience that fits the job comes first. Your master resume is never changed.",
  },
  {
    question: "Can it add skills or experience I don't have?",
    answer:
      "No. Employers, job titles, dates, locations, degrees, contact details and links are copied from your resume unchanged, and no skill, tool, number or place is added unless it is already in your resume. If the agent can't tailor within those rules, it uses your original resume.",
  },
  {
    question: "How do I know the tailored resume is better?",
    answer:
      "Each tailored resume is scored against the job description next to your original. If the score doesn't go up, your original resume is used instead.",
  },
  {
    question: "What happens to keywords I'm missing?",
    answer:
      "Keywords from the job that aren't in your resume are listed in a keyword report instead of being added. If you do have that experience, add it to your resume and tailor again.",
  },
  {
    question: "How many credits does it use?",
    answer:
      "A tailored resume uses 2 credits. You are only charged when a tailored resume is produced. If your original resume is used, no credits are charged.",
  },
  {
    question: "Which job sites does it work on?",
    answer:
      "Tailored Apply works on job pages you open in Chrome with the MindMyJob extension, including LinkedIn, Naukri, Indeed, Foundit and company career sites. Install the extension from the How to Use page.",
  },
];

export const seo: AgentPageSeo = {
  slug: "tailored-apply",
  name: "Tailored Apply Agent",
  title: "Tailored Apply Agent: A Tailored Resume in One Click | MindMyJob",
  description:
    "Click once on any job in Chrome. The Tailored Apply Agent rewrites your resume around the job's keywords, keeps your facts intact and submits the application.",
  keywords: [
    "tailored apply",
    "tailor resume to job description",
    "ai resume tailoring",
    "one click job apply",
    "ats optimized resume for each job",
    "resume keyword matching",
    "ai job application chrome extension",
    "apply with tailored resume",
    "customize resume for every job",
    "ai job agent",
  ],
  ogImage: "/assets/images/ai-agents/tailored-apply/hero-one-click.png",
  ogImageAlt:
    "MindMyJob Tailored Apply Agent tailoring a resume and applying from a job page",
  featureList: [
    "One-click apply from any job page in Chrome",
    "Resume tailored to each job description",
    "Employers, titles, dates and degrees kept unchanged",
    "ATS score before and after tailoring",
    "Keyword report for skills missing from your resume",
    "Application form filled from your profile",
    "Credits charged only for a tailored resume",
  ],
  faqs,
};
